/* WallMonkeys mega menu + mobile drawer — assets/wm-mega-menu.js
   W3C APG "disclosure navigation (hybrid)": top-level text is a real link, the chevron
   is a <button aria-expanded aria-controls>. Hover intent: 200ms open, 300ms close grace,
   instant switch once a panel is open. Esc closes and returns focus. No dependencies. */
(function () {
  function initDesktop(nav) {
    if (!nav || nav.dataset.wmmReady) return;
    nav.dataset.wmmReady = '1';
    var items = [].slice.call(nav.querySelectorAll('[data-wmm-item]'));
    var openItem = null, openTimer = null, closeTimer = null;
    var OPEN_DELAY = 200, CLOSE_DELAY = 300;

    function panelOf(item) { return item.querySelector(':scope > .wmm__panel'); }
    function btnOf(item) { return item.querySelector(':scope > .wmm__top > .wmm__toggle'); }

    function open(item) {
      if (openItem === item) return;
      if (openItem) close(openItem);
      var p = panelOf(item), b = btnOf(item);
      if (!p) return;
      p.hidden = false; item.classList.add('is-open');
      if (b) b.setAttribute('aria-expanded', 'true');
      openItem = item;
    }
    function close(item) {
      var p = panelOf(item), b = btnOf(item);
      if (p) p.hidden = true;
      item.classList.remove('is-open');
      if (b) b.setAttribute('aria-expanded', 'false');
      if (openItem === item) openItem = null;
      if (item._wmmPending) { p.innerHTML = item._wmmPending; item._wmmPending = null; }
    }
    nav._wmmIsOpen = function (item) { return openItem === item; };
    function clearTimers() { clearTimeout(openTimer); clearTimeout(closeTimer); }

    items.forEach(function (item) {
      var b = btnOf(item);
      item.addEventListener('mouseenter', function () {
        if (window.matchMedia('(hover: none)').matches) return;
        clearTimers();
        if (openItem) { open(item); } else { openTimer = setTimeout(function () { open(item); }, OPEN_DELAY); }
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { if (openItem === item) close(item); }, CLOSE_DELAY);
      });
      if (b) b.addEventListener('click', function (e) {
        e.preventDefault(); clearTimers();
        if (openItem === item) { close(item); } else { open(item); }
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && openItem === item) { close(item); if (b) b.focus(); }
      });
      item.addEventListener('focusout', function (e) {
        if (openItem === item && !item.contains(e.relatedTarget)) close(item);
      });
    });

    // Rail (Wall Decals panel): hover/focus a group shows its pane. Delegated, so it keeps
    // working after the image version of the panels is swapped in.
    function activateRail(e) {
      var li = e.target.closest && e.target.closest('[data-wmm-rail]');
      if (!li || !nav.contains(li)) return;
      var wrap = li.closest('.wmm__rail-wrap');
      [].forEach.call(wrap.querySelectorAll('[data-wmm-rail]'), function (x) { x.classList.toggle('is-active', x === li); });
      [].forEach.call(wrap.querySelectorAll('[data-wmm-pane]'), function (p) { p.hidden = p.id !== li.getAttribute('data-wmm-rail'); });
    }
    nav.addEventListener('mouseover', activateRail);
    nav.addEventListener('focusin', activateRail);

    document.addEventListener('click', function (e) { if (openItem && !nav.contains(e.target)) close(openItem); });

    // Highlight current scope (Baymard): mark the top item whose subtree contains this URL.
    var path = location.pathname.replace(/\/$/, '');
    items.forEach(function (item) {
      var hit = [].some.call(item.querySelectorAll('a[href]'), function (a) {
        var h = a.getAttribute('href').split('?')[0].replace(/\/$/, '');
        return h && h !== '' && h === path;
      });
      if (hit) item.classList.add('is-current');
    });
  }

  /* ---------- Menu images ----------
     The header renders the menu text-only (fast, crawlable). The image version comes from
     sections/wm-mega-menu.liquid via Shopify's Section Rendering API: one URL for every page,
     so Shopify serves it from cache. Fetched when the browser is idle, or on first hover/open. */
  var imgPromise = null;
  function loadImages() {
    if (imgPromise) return imgPromise;
    var nav = document.querySelector('[data-wmm]');
    if (!nav || nav.getAttribute('data-wmm-images') !== 'false') return (imgPromise = Promise.resolve());
    var root = (nav.getAttribute('data-wmm-root') || '/').replace(/\/?$/, '/');
    var key = 'wmm:' + (window.Shopify && Shopify.theme ? Shopify.theme.id : '') + ':' + root;
    var cached = null;
    try { cached = sessionStorage.getItem(key); } catch (e) {}
    var get = cached ? Promise.resolve(cached) : fetch(root + '?section_id=wm-mega-menu', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); });
    imgPromise = get.then(function (html) {
      var src = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-wmm]');
      if (!src) return;
      var a = nav.querySelectorAll('[data-wmm-item]'), b = src.querySelectorAll('[data-wmm-item]');
      if (a.length !== b.length) return;
      if (!cached) { try { sessionStorage.setItem(key, html); } catch (e) {} }
      [].forEach.call(a, function (item, i) {
        var p1 = item.querySelector(':scope > .wmm__panel'), p2 = b[i].querySelector(':scope > .wmm__panel');
        if (!p1 || !p2) return;
        if (nav._wmmIsOpen && nav._wmmIsOpen(item)) item._wmmPending = p2.innerHTML; // swap when it closes
        else p1.innerHTML = p2.innerHTML;
      });
      nav.setAttribute('data-wmm-images', 'true');
    }).catch(function () {});
    return imgPromise;
  }

  /* ---------- Mobile drawer ----------
     Off-canvas drawer that replaces Debut's push-down mobile nav.
     It is built in the browser from the desktop mega menu markup (already in the page), so the
     server renders menu links + images once instead of twice. Opens from Debut's hamburger
     (.js-mobile-nav-toggle) below 750px. */
  var SVG_CHEV = '<svg viewBox="0 0 8 14" aria-hidden="true" focusable="false"><path d="M1 1l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>';

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function txt(node) { return node ? node.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function href(a) { return a ? a.getAttribute('href') : '#'; }
  // Ask Shopify's CDN for a sharper image on mobile (desktop tiles are smaller).
  function sized(src, w) {
    if (!src) return '';
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$1' + w) : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function imgSrc(scope) { var i = scope && scope.querySelector('img'); return i ? i.getAttribute('src') : ''; }

  function readMenu(src) {
    var tiles = function (scope) {
      return [].map.call(scope.querySelectorAll('.wmm__tile a'), function (a) {
        return { title: txt(a.querySelector('.wmm__tile-label')), url: href(a), img: imgSrc(a) };
      });
    };
    return [].map.call(src.querySelectorAll('.wmm__bar > [data-wmm-item]'), function (li) {
      var top = li.querySelector('.wmm__toplink');
      var panel = li.querySelector('.wmm__panel');
      var o = { title: txt(top), url: href(top), type: 'link' };
      if (!panel) return o;
      if (panel.classList.contains('wmm__panel--simple')) {
        o.type = 'simple';
        o.links = [].map.call(panel.querySelectorAll('.wmm__list a'), function (a) { return { title: txt(a), url: href(a) }; });
      } else if (panel.querySelector('.wmm__rail-wrap')) {
        o.type = 'rail';
        o.groups = [].map.call(panel.querySelectorAll('[data-wmm-rail]'), function (r) {
          var pane = panel.querySelector('#' + r.getAttribute('data-wmm-rail'));
          var all = pane && pane.querySelector('.wmm__shopall');
          return {
            title: txt(r.querySelector('a')), url: href(r.querySelector('a')),
            img: imgSrc(pane) || imgSrc(r),
            all: all ? { text: txt(all).replace(/\s*→$/, ''), url: href(all) } : null,
            tiles: pane ? tiles(pane) : []
          };
        });
        var az = panel.querySelector('.wmm__azlink');
        o.az = az ? { text: txt(az).replace(/\s*→$/, ''), url: href(az) } : null;
        var p = panel.querySelector('.wmm__promo');
        if (p) o.promo = { url: href(p), img: imgSrc(p), kicker: txt(p.querySelector('.wmm__promo-kicker')), title: txt(p.querySelector('.wmm__promo-title')), cta: txt(p.querySelector('.wmm__promo-cta')) };
        o.img = o.groups.length ? o.groups[0].img : '';
      } else {
        o.type = 'cards';
        var btn = panel.querySelector('.wmm__btn');
        o.cta = btn ? { text: txt(btn), url: href(btn) } : null;
        o.trust = [].map.call(panel.querySelectorAll('.wmm__intro li'), txt);
        o.tiles = tiles(panel);
        o.img = o.tiles.length ? o.tiles[0].img : '';
      }
      return o;
    });
  }

  function tileGrid(list, cols, imgW, onTap) {
    var ul = el('ul', 'wmd__grid wmd__grid--' + cols);
    list.forEach(function (t) {
      var li = el('li');
      var a = el(onTap ? 'button' : 'a', 'wmd__tile');
      if (onTap) { a.type = 'button'; a.addEventListener('click', function () { onTap(t); }); } else { a.href = t.url; }
      var th = el('span', 'wmd__thumb');
      if (t.img) { var im = el('img'); im.src = sized(t.img, imgW); im.alt = ''; im.loading = 'lazy'; im.decoding = 'async'; th.appendChild(im); }
      a.appendChild(th);
      var lb = el('span', 'wmd__label', t.title); if (onTap && t.type !== 'link') lb.insertAdjacentHTML('beforeend', SVG_CHEV); a.appendChild(lb);
      li.appendChild(a); ul.appendChild(li);
    });
    return ul;
  }
  function button(text, url, cls) { var a = el('a', 'wmd__btn' + (cls ? ' ' + cls : ''), text); a.href = url; return a; }
  function promoCard(p) {
    var a = el('a', 'wmd__promo'); a.href = p.url;
    var th = el('span', 'wmd__promo-img');
    if (p.img) { var im = el('img'); im.src = sized(p.img, 240); im.alt = ''; im.loading = 'lazy'; th.appendChild(im); }
    var b = el('span', 'wmd__promo-body');
    if (p.kicker) b.appendChild(el('span', 'wmd__promo-kicker', p.kicker));
    b.appendChild(el('span', 'wmd__promo-title', p.title));
    if (p.cta) b.appendChild(el('span', 'wmd__promo-cta', p.cta));
    a.appendChild(th); a.appendChild(b);
    return a;
  }

  function initDrawer(shell) {
    if (!shell || shell.dataset.wmdReady) return;
    shell.dataset.wmdReady = '1';
    document.body.appendChild(shell); // escape Debut's transformed nav wrapper so position:fixed works
    shell.hidden = false;
    var viewport = shell.querySelector('[data-wmd-viewport]');
    var titleEl = shell.querySelector('[data-wmd-title]');
    var backBtn = shell.querySelector('[data-wmd-back]');
    var rootScreen = shell.querySelector('[data-wmd-screen="root"]');
    var stack = [rootScreen];
    var built = false, opener = null, mq = window.matchMedia('(max-width: 749px)');

    function newScreen(title) {
      var s = el('div', 'wmd__screen'); s.setAttribute('data-title', title); s.setAttribute('role', 'region'); s.setAttribute('aria-label', title);
      viewport.appendChild(s); return s;
    }
    function show(next, dir) {
      var cur = stack[stack.length - 1];
      if (dir === 'fwd') { cur.classList.remove('is-active'); cur.classList.add('is-behind'); stack.push(next); }
      else { stack.pop(); cur.classList.remove('is-active'); cur.classList.remove('is-behind'); }
      void next.offsetWidth; // start the slide from off-screen
      next.classList.remove('is-behind'); next.classList.add('is-active');
      if (dir === 'fwd') next.scrollTop = 0;
      titleEl.textContent = next.getAttribute('data-title');
      backBtn.hidden = stack.length < 2;
      if (dir === 'back') setTimeout(function () { if (cur.parentNode && stack.indexOf(cur) < 0 && cur !== rootScreen) cur.parentNode.removeChild(cur); }, 320);
      (next.querySelector('a, button') || backBtn).focus({ preventScroll: true });
    }
    function goGroup(item, g) {
      var s = newScreen(g.title);
      if (g.all) s.appendChild(button(g.all.text, g.all.url));
      s.appendChild(tileGrid(g.tiles, 3, 360));
      show(s, 'fwd');
    }
    function goItem(item) {
      if (item.type === 'link') { location.href = item.url; return; }
      var s = newScreen(item.title);
      if (item.type === 'simple') {
        var ul = el('ul', 'wmd__list');
        item.links.forEach(function (l) { var li = el('li'); var a = el('a', null, l.title); a.href = l.url; li.appendChild(a); ul.appendChild(li); });
        s.appendChild(ul);
      } else if (item.type === 'cards') {
        if (item.cta) s.appendChild(button(item.cta.text, item.cta.url));
        s.appendChild(tileGrid(item.tiles, 2, 480));
        if (item.trust.length) { var tr = el('ul', 'wmd__trust'); item.trust.forEach(function (t) { tr.appendChild(el('li', null, t)); }); s.appendChild(tr); }
      } else {
        if (item.promo) s.appendChild(promoCard(item.promo));
        s.appendChild(el('p', 'wmd__h', 'Shop by theme'));
        s.appendChild(tileGrid(item.groups, 2, 480, function (g) { goGroup(item, g); }));
        if (item.az) s.appendChild(button(item.az.text, item.az.url, 'wmd__btn--ghost'));
      }
      show(s, 'fwd');
    }
    function build() {
      if (built) return;
      var src = document.querySelector('[data-wmm]');
      if (!src) return;
      var items = readMenu(src), host = rootScreen.querySelector('[data-wmd-root]');
      var rail = items.filter(function (i) { return i.promo; })[0];
      if (rail) host.appendChild(promoCard(rail.promo));
      host.appendChild(el('p', 'wmd__h', 'Shop by category'));
      host.appendChild(tileGrid(items.filter(function (i) { return i.type !== 'simple'; }), 2, 480, goItem)); /* v2.1: every theme group on the root screen */ var themes = items.filter(function (i) { return i.type === 'rail'; })[0]; if (themes && themes.groups.length) { host.appendChild(el('p', 'wmd__h', 'Shop wall decals by theme')); var rows = el('ul', 'wmd__rows'); themes.groups.forEach(function (g) { var li = el('li'), b = el('button', 'wmd__row'); b.type = 'button'; var th = el('span', 'wmd__rowthumb'); if (g.img) { var im = el('img'); im.src = sized(g.img, 120); im.alt = ''; im.loading = 'lazy'; th.appendChild(im); } b.appendChild(th); b.appendChild(el('span', 'wmd__rowlabel', g.title)); b.insertAdjacentHTML('beforeend', SVG_CHEV); b.addEventListener('click', function () { goGroup(themes, g); }); li.appendChild(b); rows.appendChild(li); }); if (themes.az) { var al = el('li'), aa = el('a', 'wmd__row wmd__row--all'); aa.href = themes.az.url; aa.appendChild(el('span', 'wmd__rowlabel', themes.az.text)); aa.insertAdjacentHTML('beforeend', SVG_CHEV); al.appendChild(aa); rows.appendChild(al); } host.appendChild(rows); }
      var simple = items.filter(function (i) { return i.type === 'simple'; });
      if (simple.length) {
        var ul = el('ul', 'wmd__list');
        simple.forEach(function (i) {
          var li = el('li'); var b = el('button', 'wmd__row', i.title); b.type = 'button';
          b.insertAdjacentHTML('beforeend', SVG_CHEV); b.addEventListener('click', function () { goItem(i); });
          li.appendChild(b); ul.appendChild(li);
        });
        host.appendChild(ul);
      }
      built = true;
    }
    function open(from) {
      if (!built) {
        var done = false, go = function () { if (!done) { done = true; build(); } };
        loadImages().then(go); setTimeout(go, 1500); // never wait more than 1.5s for images
      }
      opener = from || null;
      shell.classList.add('is-open');
      document.documentElement.classList.add('wmd-lock');
      shell.querySelector('[data-wmd-close]').focus({ preventScroll: true }); // v2.1: never auto-focus search (pops the phone keyboard)
    }
    function close() {
      shell.classList.remove('is-open');
      document.documentElement.classList.remove('wmd-lock');
      while (stack.length > 1) { var s = stack.pop(); if (s.parentNode) s.parentNode.removeChild(s); }
      rootScreen.classList.add('is-active'); rootScreen.classList.remove('is-behind');
      titleEl.textContent = rootScreen.getAttribute('data-title'); backBtn.hidden = true;
      if (opener) opener.focus({ preventScroll: true });
    }

    // Take over Debut's hamburger on small screens (capture phase runs before Debut's handler).
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('.js-mobile-nav-toggle');
      if (!t || !mq.matches) return;
      e.preventDefault(); e.stopPropagation();
      if (shell.classList.contains('is-open')) close(); else open(t);
    }, true);
    shell.addEventListener('click', function (e) {
      if (e.target.closest('[data-wmd-close]')) close();
      else if (e.target.closest('[data-wmd-back]')) show(stack[stack.length - 2], 'back');
    });
    shell.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return; // keep focus inside the open drawer
      var f = [].filter.call(shell.querySelectorAll('.wmd__head button:not([hidden]), .wmd__screen.is-active a, .wmd__screen.is-active button, .wmd__screen.is-active input'), function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(function () { if (!mq.matches && shell.classList.contains('is-open')) close(); });
    window.WMD = { open: open, close: close };
  }

  function boot() {
    var nav = document.querySelector('[data-wmm]');
    initDesktop(nav);
    initDrawer(document.querySelector('[data-wmd]'));
    if (nav) {
      nav.addEventListener('mouseover', loadImages, { once: true });
      nav.addEventListener('focusin', loadImages, { once: true });
    }
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1200); };
    if (document.readyState === 'complete') idle(loadImages, { timeout: 4000 });
    else window.addEventListener('load', function () { idle(loadImages, { timeout: 4000 }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.WMM = { boot: boot, loadImages: loadImages };
})();